// components
import { Container } from 'components/Grid';
import {
  MirandaSecondaryButton,
  MirandaHollowSecondaryButton,
} from '@/components/Button/BaseButton';

import { VideoPlayer } from '@/containers-m/VideoPlayer';

// styles
import {
  LifeLoadVideoWrapper,
  Title,
  MediaWrapper,
  CTAWrapper,
} from './LifeLoadVideo.styles';

export function LifeLoadVideo() {
  const video_settings = {
    youtube: 'https://www.youtube.com/watch?v=TPaNcx_NowY?rel=0',
    thumb: '/images/home/thumb/life-load.png',
    preview: '/videos/home/bg_life-load.webm',
  };

  return (
    <LifeLoadVideoWrapper>
      <Container>
        <Title>Reinventing the future of freight operations</Title>

        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>
      </Container>
      <CTAWrapper>
        <MirandaSecondaryButton as="a" href="/shipper/#hubspot-form">
          Request a Demo
        </MirandaSecondaryButton>
        <MirandaHollowSecondaryButton
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href="https://lp.loadsmart.com/case-studies"
        >
          Explore our Case Studies
        </MirandaHollowSecondaryButton>
      </CTAWrapper>
    </LifeLoadVideoWrapper>
  );
}
